export const READY_FOR_REVIEW = 'Ready for review';
export const UNDER_REVIEW = 'Under review';
export const FINALIZED = 'Finalized';
export const READY_FOR_CAP = 'Ready for cap';
export const UNDER_CAP = 'Under cap';
export const CAP_DEVELOPMENT = 'Cap development';
export const CAP_IMPLEMENTATION = 'Cap implementation';
export const CAP_COMPLETED = 'Cap completed';
export const FINALIZED_CAP = 'Finalized cap';
export const READY_FOR_EXTERNAL_SAQ = 'Ready for external saq';
export const UNDER_EXTERNAL_SAQ = 'Under external saq';
export const READY_FOR_INTERNAL_SAQ = 'Ready for internal saq';
export const UNDER_INTERNAL_SAQ = 'Under internal saq';
export const LOADING_RESULTS = 'Loading results';
export const NOT_YET_STARTED = 'Not yet started';
export const IN_PROCESS = 'In process';
export const VERIFIER_REVIEW_PENDING = 'Verifier review pending';
export const VERIFIER_REVIEW_UNDERWAY = 'Verifier review underway';
export const VERIFIER_REVISION_REQUESTED = 'Verifier revision requested';
export const VERIFIER_REVISION_UNDERWAY = 'Verifier revision underway';
export const REVIEWER_REVIEW_PENDING = 'Reviewer review pending';
export const REVIEWER_REVIEW_UNDERWAY = 'Reviewer review underway';
export const REVIEWER_REVISION_REQUESTED = 'Reviewer revision requested';
export const COMPLETED = 'Completed';
// Cap type
export const DEVELOPMENT_SUPPORT = 'development_support';

// Job cap status
export const CAP_PROCESS_COMPLETE = ['cap_process_complete', 'cap_process_complete_all_findings_closed', 'cap_process_complete_on_site_verification_pending'];

export const STATUSES = {
  ready_for_review: READY_FOR_REVIEW,
  under_review: UNDER_REVIEW,
  finalized: FINALIZED,
  ready_for_cap: READY_FOR_CAP,
  under_cap: UNDER_CAP,
  cap_development: CAP_DEVELOPMENT,
  cap_implementation: CAP_IMPLEMENTATION,
  cap_completed: CAP_COMPLETED,
  finalized_cap: FINALIZED_CAP,
  ready_for_external_saq: READY_FOR_EXTERNAL_SAQ,
  under_external_saq: UNDER_EXTERNAL_SAQ,
  ready_for_internal_saq: READY_FOR_INTERNAL_SAQ,
  under_internal_saq: UNDER_INTERNAL_SAQ,
  loading_results: LOADING_RESULTS,
};

export const filterJobType = (input, words) => {
  const map1 = words.map( word => !!word.includes(input))
  return map1;
};